import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AccountService } from "./account.service";
import { SCAMP_API, APP_SETTINGS } from "src/environments/environment";
import { Observable } from "rxjs";
import {
  EquipamentoComboBoxViewModel,
  ParametersPesquisaEquipamento,
} from "../pages/domain/viewmodels.models";

@Injectable({ providedIn: "root" })
export class EquipamentoService {
  constructor(private http: HttpClient, private account: AccountService) {}

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/equipamentos`, {
      headers: this.account.composeHeaders(),
    });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${SCAMP_API.accountApiV1}/equipamentos/${id}`, {
      headers: this.account.composeHeaders(),
    });
  }

  getByIdOrNSerie(identificador: string): Observable<any> {
    return this.http.get<any>(
      `${SCAMP_API.accountApiV1}/equipamentos/por-identificador/${identificador}`,
      { headers: this.account.composeHeaders() }
    );
  }

  getByIdOrNSerieSumary(identificador: string): Observable<any> {
    return this.http.get<any>(
      `${SCAMP_API.accountApiV1}/equipamentos/por-identificador-resumo/${identificador}`,
      { headers: this.account.composeHeaders() }
    );
  }

  getEquipamentosForComboBox(): Observable<EquipamentoComboBoxViewModel[]> {
    return this.http.get<EquipamentoComboBoxViewModel[]>(
      `${SCAMP_API.accountApiV1}/equipamentos/para-combobox`,
      { headers: this.account.composeHeaders() }
    );
  }

  post(data: any): Observable<any> {
    return this.http.post(`${SCAMP_API.accountApiV1}/equipamentos`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  getPlanoManutencaoExcel(
    equipamentosIds: string,
    anoProximaExecucao: string
  ): Observable<any> {
    return this.http.post(
      `${SCAMP_API.accountApiV1}/equipamentos/plano-manutencao`,
      { equipamentosIds, anoProximaExecucao },
      { headers: this.account.composeHeaders() }
    );
  }

  nomeJaCadastrado(nome: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${SCAMP_API.accountApiV1}/equipamentos/nome-nao-cadastrado/${nome}`,
      { headers: this.account.composeHeaders() }
    );
  }

  numeroSerieJaCadastrada(numeroserie: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${SCAMP_API.accountApiV1}/equipamentos/numeroserie-nao-cadastrada/${numeroserie}`,
      { headers: this.account.composeHeaders() }
    );
  }

  getEquipamentosPorLocalId(
    localId: number
  ): Observable<EquipamentoComboBoxViewModel[]> {
    return this.http.get<EquipamentoComboBoxViewModel[]>(
      `${SCAMP_API.accountApiV1}/equipamentos/por-local/${localId}`,
      { headers: this.account.composeHeaders() }
    );
  }

  delete(id: number) {
    return this.http.delete(`${SCAMP_API.accountApiV1}/equipamentos/${id}`, {
      headers: this.account.composeHeaders(),
    });
  }

  busca(parameter: ParametersPesquisaEquipamento): Observable<any[]> {
    parameter.tipoLocal = APP_SETTINGS.tipoLocal;

    return this.http.post<any[]>(
      `${SCAMP_API.accountApiV1}/equipamentos/busca`,
      parameter,
      { headers: this.account.composeHeaders() }
    );
  }

  // ------------------------------------------
}
